// Corrected the file path in the comment to match the actual file structure
// src/data/PortfolioData.ts

import { Homeimages, Portfolio } from '../../../assets';
export type Img = { src: string; alt: string };
export type PortfolioDetail = {
  id: string;
  breadcrumb: { current: string; previous?: string };
  heading: string;
  mainImage: string | Img;
  topImage?: string | Img;
  bottomImage?: string | Img;
  projectData: { program: string; year: string; location: string };
  title: string;
  paragraph: string[];
  bulletList: string[];
  sectionTitle: string;
  sectionText: string;
  steps: { title: string; text: string }[];
  finalText: string[];
};
const fallbackAlt = (
  item: PortfolioDetail,
  position: 'main' | 'top' | 'bottom',
) =>
  `${item.heading || item.breadcrumb?.current || item.id} – ${position} image`;

// Coerce string or missing alt into {src, alt}
const toImg = (img: string | Img | undefined, fb: string): Img | undefined => {
  if (!img) return undefined;
  return typeof img === 'string'
    ? { src: img, alt: fb }
    : { src: img.src, alt: (img.alt || fb).trim() };
};

export const PortfolioDetailsData: PortfolioDetail[] = [
  {
    id: 'seta event',
    breadcrumb: {
      current: 'SETA EVENT',
      previous: 'Home',
    },
    heading: 'Seta Event',
    mainImage: 'https://dprstorage.b-cdn.net/RW/exhibit1.png',
    topImage: 'https://dprstorage.b-cdn.net/RW/exhibit1.png',
    projectData: {
      program: 'SEAT Event',
      year: ' 2024',
      location: 'Hyderabad',
    },
    title: 'An Unforgettable Experience Moderating the SETA Event',
    paragraph: [
      'Moderating the SETA event was an enriching and unforgettable experience! I am truly grateful to everyone involved for bringing such incredible energy, collaboration, and a spirit of innovation to the table. The event was a perfect blend of creativity and forward-thinking ideas that made every moment valuable.',
      'A special thank you to the inspiring panelists and participants. Your insights into the industry were nothing short of brilliant. It was a privilege to witness firsthand the thought leadership and expertise you brought to the discussions. I am honored to have played a part in such a pivotal event that highlights the future of technology.',

      'A special thank you to the inspiring panelists and participants. Your insights into the industry were nothing short of brilliant. It was a privilege to witness firsthand the thought leadership and expertise you brought to the discussions. I am honored to have played a part in such a pivotal event that highlights the future of technology.',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: ``,
    steps: [],
    bottomImage: 'https://dprstorage.b-cdn.net/RW/portinnerf1.png',
    finalText: [],
  },

  {
    id: 'Inspiring Future',
    breadcrumb: {
      current: 'INSPIRING FUTURE',
      previous: 'Home',
    },
    heading: 'Inspiring Future',
    mainImage: 'https://dprstorage.b-cdn.net/RW/exhibit3.png',

    topImage: 'https://dprstorage.b-cdn.net/RW/exhibit3.png',
    projectData: {
      program: 'Inspiring Day Program',
      year: ' 2024',
      location: 'Siddipet',
    },
    title: 'An Inspiring Day at University Postgraduate College (OU), Siddipet',
    paragraph: [
      'I had the incredible honor of being a guest speaker at the One-Day Workshop on Design Thinking & Career Building at the University Postgraduate College (OU), Siddipet. The experience was truly enriching, as I got to connect with a dynamic group of students brimming with ambition and a drive to shape their careers.',
      'As a Top Property Consultant in Hyderabad, I emphasized the importance of skills like personal branding, social media strategies, personality development, effective communication, LinkedIn networking, and resume building. It was a joy to see the students engage so enthusiastically with these topics, absorbing ideas that will empower them to craft successful and impactful career paths.',
      'A special thanks to Brigadier Inder Sethi, Veteran Sir, for the warm introduction and for inviting me to this prestigious event. The unwavering support and hospitality from the college faculty and students made the day truly unforgettable.',
      'What stood out the most was the energy and determination radiating from the room. These young individuals are not just envisioning success—they are taking active steps toward achieving it. Witnessing their commitment to personal growth was both inspiring and humbling.',
      'To the entire college community, thank you for the opportunity to contribute and learn alongside you. Together, we are nurturing a generation of leaders who will leave a lasting impact.',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    bottomImage: 'https://dprstorage.b-cdn.net/RW/portinner2-1.png',
    finalText: [],
  },
  {
    id: 'Sales Mentoring',
    breadcrumb: {
      current: 'SALES MENTORING',
      previous: 'Home',
    },
    heading: 'Sales Mentoring',
    mainImage: 'https://dprstorage.b-cdn.net/RW/salesprograminner.png',

    topImage: 'https://dprstorage.b-cdn.net/RW/salesprograminner.png',
    projectData: {
      program: 'Anantha Projects',
      year: ' 2024',
      location: 'Kurnool',
    },
    title:
      'Mastering the Art of Luxury Sales with the Best Real Estate Mentor in Hyderabad',
    paragraph: [
      'Our first day of training with the dedicated team was nothing short of amazing! Under the guidance of the best real estate mentor in Hyderabad, we delved deep into mastering the perfect pitch for selling luxury villas. The day was focused on honing their skills and preparing them to excel as professional real estate sales experts.',
      'From building genuine connections with clients to effectively presenting the true value of luxury living, the team covered essential elements to succeed in high-end real estate. A key part of the training was centered on building confidence an indispensable trait when dealing with luxury clients.',
      'The best real estate mentor in Hyderabad also emphasized the importance of understanding client needs. The team learned how to tailor their approach to align with the aspirations of each client, offering personalized solutions that reflect the exclusive lifestyle luxury homes provide.',
      'Moreover, they were taught to highlight not just the features of the property but the lifestyle it offers. Excellence in every interaction was the primary goal, ensuring the client experience is unmatched.',
      "This first day is just the beginning of an exciting journey, and we're thrilled to watch this team grow into top real estate professionals in the luxury market",
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    bottomImage: '',
    finalText: [],
  },
  {
    id: '𝗔𝗻 𝗘𝗻𝗰𝗼𝘂𝗻𝘁𝗲𝗿 𝘄𝗶𝘁𝗵 𝗩𝗶𝘀𝗶𝗼𝗻, 𝗖𝘂𝗹𝘁𝘂𝗿𝗲 & 𝗖𝗼𝗻𝘀𝗰𝗶𝗼𝘂𝘀 𝗟𝗶𝘃𝗶𝗻𝗴',
    breadcrumb: {
      current: 'AN ENCOUNTER WITH VISION, CULTURE & CONSCIOUS LIVING',
      previous: 'Home',
    },
    heading: '𝗔𝗻 𝗘𝗻𝗰𝗼𝘂𝗻𝘁𝗲𝗿 𝘄𝗶𝘁𝗵 𝗩𝗶𝘀𝗶𝗼𝗻, 𝗖𝘂𝗹𝘁𝘂𝗿𝗲 &𝗖𝗼𝗻𝘀𝗰𝗶𝗼𝘂𝘀 𝗟𝗶𝘃𝗶𝗻𝗴',
    mainImage: 'https://dprstorage.b-cdn.net/RW/portfolio_parvathireddy.jpg',

    topImage: 'https://dprstorage.b-cdn.net/RW/portfolio_parvathireddy.jpg',
    projectData: {
      program: '',
      year: ' ',
      location: '',
    },
    title: '𝗔𝗻 𝗘𝗻𝗰𝗼𝘂𝗻𝘁𝗲𝗿 𝘄𝗶𝘁𝗵 𝗩𝗶𝘀𝗶𝗼𝗻, 𝗖𝘂𝗹𝘁𝘂𝗿𝗲 & 𝗖𝗼𝗻𝘀𝗰𝗶𝗼𝘂𝘀 𝗟𝗶𝘃𝗶𝗻𝗴',
    paragraph: [
      'In a meaningful exchange of ideas and inspiration, we had the distinct privilege of meeting 𝗠𝗿𝘀. 𝗣𝗮𝗿𝘃𝗮𝘁𝗵𝗶 𝗥𝗲𝗱𝗱𝘆, a dynamic leader with a remarkable vision titled “𝘽𝙮 𝙩𝙝𝙚 𝙍𝙞𝙫𝙚𝙧”, a development that seamlessly integrates luxury with nature, art, and conscious community living.',
      'Rooted in the 𝗽𝗵𝗶𝗹𝗼𝘀𝗼𝗽𝗵𝘆 𝗼𝗳 𝗰𝗼𝗻𝘀𝗰𝗶𝗼𝘂𝘀 𝗹𝗶𝘃𝗶𝗻𝗴, By the River offers more than luxury farm plots; it is a sanctuary where 𝗮𝗿𝘁, 𝘀𝘂𝘀𝘁𝗮𝗶𝗻𝗮𝗯𝗶𝗹𝗶𝘁𝘆, 𝗮𝗻𝗱 𝗿𝘂𝗿𝗮𝗹 𝗰𝗵𝗮𝗿𝗺 converge. From koi ponds and lotus-filled waterbodies to 𝘁𝗿𝗼𝗽𝗶𝗰𝗮𝗹 𝗴𝗮𝗿𝗱𝗲𝗻𝘀, curated art installations, and wellness-centric amenities, every detail evokes elegance with purpose.',
      'As part of our interaction, I had the opportunity to tour her residence. As I glanced through the space, I observed 𝗮 𝗰𝗼𝗹𝗹𝗲𝗰𝘁𝗶𝗼𝗻 𝗼𝗳 𝘂𝗻𝗶𝗾𝘂𝗲 𝗮𝗿𝘁𝘄𝗼𝗿𝗸𝘀, 𝘀𝗰𝘂𝗹𝗽𝘁𝘂𝗿𝗲𝘀, and 𝘁𝗵𝗼𝘂𝗴𝗵𝘁𝗳𝘂𝗹𝗹𝘆 𝗽𝗹𝗮𝗰𝗲𝗱 𝗮𝗿𝘁𝗶𝗳𝗮𝗰𝘁𝘀.',
      'The home felt like a 𝗹𝗶𝘃𝗶𝗻𝗴 𝗺𝘂𝘀𝗲𝘂𝗺 𝗿𝗶𝗰𝗵 𝗶𝗻 𝗵𝗲𝗿𝗶𝘁𝗮𝗴𝗲, 𝗶𝗻𝘁𝗲𝗻𝘁𝗶𝗼𝗻𝗮𝗹 𝗱𝗲𝘀𝗶𝗴𝗻, and 𝗰𝘂𝗹𝘁𝘂𝗿𝗮𝗹 𝗱𝗲𝗽𝘁𝗵. It beautifully reflects the values present in her work: cultural richness, meticulous attention to detail, and a deep connection to nature and beauty.',
      'We are grateful for this inspiring meeting and the opportunity to witness a vision that is shaping not just spaces, but 𝗹𝗶𝗳𝗲𝘀𝘁𝘆𝗹𝗲𝘀 𝗿𝗼𝗼𝘁𝗲𝗱 𝗱𝗲𝗲𝗽𝗹𝘆 𝗕𝘆 𝘁𝗵𝗲 𝗥𝗶𝘃𝗲𝗿.',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    bottomImage: '',
    finalText: [],
  },
  {
    id: 'Honer Homes Experience',
    breadcrumb: {
      current: 'HONER HOMES EXPERIENCE',
      previous: 'Home',
    },
    heading: '',
    mainImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/honerhomes_portfolio1.jpeg',
      alt: 'Honer Homes Experience_mainImage',
    },

    topImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/honerhomes_portfolio1.jpeg',
      alt: 'Honer Homes Experience_topImage',
    },
    projectData: {
      program: '',
      year: ' ',
      location: '',
    },
    title: '',
    paragraph: [
      'We had the privilege of attending the launch ceremony of the Honer Homes Experience Centre in Kukatpally, and honestly, it didn’t feel like a real estate venue at all.',
      "Spread across 3.5 acres, the space had everything, director cabins, show flats, kids' play zones, open lounges, Conference room, a Huge Presentation Area / larger than life LED Screen— but what really stood out was the vibe. It felt more like stepping into the lobby of a super luxurious hotel. Warm lighting, calm energy, and every detail thoughtfully done.",
      "A big thank you to Ms. 𝗟𝗮𝗹𝗶𝘁𝗵𝗮, Managing Director of RS Brothers, for inviting us. She's now stepping into real estate, and what a bold, beautiful start this is.",
      'A special thanks to shrikanth Channappa for being an incredibly warm and thoughtful host; your hospitality truly stood out!',
      "The event brought together some of Hyderabad's most respected real estate professionals — from Mr. C Shekar Reddy (Vice Chairman, IGBC) to Mr. 𝗩𝗲𝗻𝘂 𝗩𝗶𝗻𝗼𝗱 (MD, CYBERCITY Builders & Developers ), and many more familiar faces from the industry.",
      'We also got to reconnect with some amazing people from the industry — old friends and familiar faces. It was great catching up with Preeti Paruchuri and Santosh Parachuri from the Bennett Coleman & Co. Ltd. (The Times of India), and meeting many top developers and industry leaders who’ve been part of Hyderabad’s growth story. Always a pleasure when good work brings good people together.',
      'There was good food, great music with live artists, and even better conversations. It felt less like an event, more like a gathering of passionate people coming together to witness something new.',
      'Wishing Ms. 𝗟𝗮𝗹𝗶𝘁𝗵𝗮 garu and the entire Honer Homes team all the best on this journey. If this launch is any sign of what’s coming — it’s going to be something special.',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    bottomImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/honerhomes_portfolio2.jpeg',
      alt: 'Honer Homes Experience_bottomImage',
    },
    finalText: [],
  },
  {
    id: '𝗲𝘃𝗼𝗹𝘃𝗶𝗻𝗴 𝗳𝗮𝗰𝗲 of 𝗛𝘆𝗱𝗲𝗿𝗮𝗯𝗮𝗱’𝘀 𝗿𝗲𝗮𝗹 𝗲𝘀𝘁𝗮𝘁𝗲 𝗺𝗮𝗿𝗸𝗲',
    breadcrumb: {
      current: 'EVOLVING FACE OF HYDERABAD’S REAL ESTATE MARKET',
      previous: 'Home',
    },
    heading: '',
    mainImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/newmark_portfolio1.jpg',
      alt: 'evolving face of main_Image',
    },

    topImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/newmark_portfolio1.jpg',
      alt: 'evolving face of top_Image',
    },

    projectData: {
      program: '',
      year: ' ',
      location: '',
    },
    title: '',
    paragraph: [
      'Had a wonderful time meeting Vishal Reddy Gopu, the young & upcoming 𝗲𝗻𝘁𝗿𝗲𝗽𝗿𝗲𝗻𝗲𝘂𝗿 at 𝗩𝗮𝗺𝘀𝗶𝗿𝗮𝗺 𝗡𝗲𝘄𝗺𝗮𝗿𝗸.',
      'During our visit, we explored the 𝗲𝘃𝗼𝗹𝘃𝗶𝗻𝗴 𝗳𝗮𝗰𝗲 of 𝗛𝘆𝗱𝗲𝗿𝗮𝗯𝗮𝗱’𝘀 𝗿𝗲𝗮𝗹 𝗲𝘀𝘁𝗮𝘁𝗲 𝗺𝗮𝗿𝗸𝗲𝘁 — with a special lens on the rising demand for #UberLuxury spaces.',
      'As someone who has observed this industry transform over two decades, it’s deeply fulfilling to see the next generation step forward — not just to carry forward a #legacy, but to 𝗲𝗹𝗲𝘃𝗮𝘁𝗲 𝗶𝘁 𝘄𝗶𝘁𝗵 𝗳𝗿𝗲𝘀𝗵 𝘁𝗵𝗶𝗻𝗸𝗶𝗻𝗴, 𝗰𝗹𝗮𝗿𝗶𝘁𝘆, 𝗮𝗻𝗱 𝗮𝗺𝗯𝗶𝘁𝗶𝗼𝗻.',
      '#VamsiramNewmark is more than a project — it’s a bold narrative of scale, elegance, and experience. It reflects a 𝗻𝗲𝘄-𝗮𝗴𝗲 𝘃𝗶𝘀𝗶𝗼𝗻 that understands both 𝗮𝘀𝗽𝗶𝗿𝗮𝘁𝗶𝗼𝗻 𝗮𝗻𝗱 𝗲𝘅𝗲𝗰𝘂𝘁𝗶𝗼𝗻',
      'Vishal’s commitment and hands-on approach speak volumes. It’s always inspiring to meet 𝘆𝗼𝘂𝗻𝗴 𝗹𝗲𝗮𝗱𝗲𝗿𝘀 who are not just managing projects — but 𝗱𝗿𝗶𝘃𝗶𝗻𝗴 𝗺𝗼𝘃𝗲𝗺𝗲𝗻𝘁𝘀.',
      'To Vishal and the Vamsiram Builders and Developers Private Limited Sohini Badvelu Newmark Urbanspaces Team —',
      '𝗧𝗵𝗮𝗻𝗸 𝘆𝗼𝘂 𝗳𝗼𝗿 𝘁𝗵𝗲 𝗶𝗻𝘀𝗶𝗴𝗵𝘁, 𝘁𝗵𝗲 𝘄𝗮𝗿𝗺𝘁𝗵, 𝗮𝗻𝗱 𝘁𝗵𝗲 𝗶𝗻𝘀𝗽𝗶𝗿𝗮𝘁𝗶𝗼𝗻.',
      'Excited for Newmark to leave its mark on Hyderabad’s iconic skyline.  ',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    bottomImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/newmark_portfolio2.jpeg',
      alt: 'evolving face of bottom_Image',
    },
    finalText: [],
  },
  {
    id: 'Annual General Body Meeting',
    breadcrumb: {
      current: 'ANNUAL GENERAL BODY MEETING',
      previous: 'Home',
    },
    heading: '',
    mainImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/chairmanofrajnews_portfolio.jpeg',
      alt: 'Annual General body Metting_mainImage',
    },

    topImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/chairmanofrajnews_portfolio.jpeg',
      alt: 'Annual General body Metting_topImage',
    },
    projectData: {
      program: '',
      year: ' ',
      location: '',
    },
    title: '',
    paragraph: [
      'It was an eventful evening meeting all the esteemed members of the HRA & NAR India at the 11th Annual General Body Meeting on 10th April 2025 at Marigold Hotel, Begumpet.',
      'It was a pleasure connecting with fellow professionals and engaging in thoughtful conversations. The presence of esteemed members from NAR India made it even more special.',
      'Grateful for the great vibes, meaningful discussions, and the lovely cocktail dinner that wrapped up the evening beautifully.',
      '𝗦𝗽𝗲𝗰𝗶𝗮𝗹 𝗠𝗲𝗻𝘁𝗶𝗼𝗻 - 𝗖𝗵𝗮𝗶𝗿𝗺𝗮𝗻 𝗼𝗳 𝗥𝗮𝗷 𝗡𝗲𝘄𝘀 𝗧𝗲𝗹𝘂𝗴𝘂',
      'Mrs. Lakshmi Rao had graced the occasion with her presence.',
      '𝗖𝗵𝗮𝗶𝗿𝗺𝗮𝗻 𝗼𝗳 𝗡𝗔𝗥 𝗜𝗻𝗱𝗶𝗮 - Mr. Sumanth Reddy Arani has been instilled as the New President of the Hyderabad Realtors Association which is a Proud Moment for HRA to have a National Level Leader head the association with immense vision, clarity & strategy.',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    bottomImage: '',
    finalText: [],
  },
  {
    id: '𝗱𝗲𝗽𝘁𝗵 𝗼𝗳 𝗸𝗻𝗼𝘄𝗹𝗲𝗱𝗴𝗲 𝗮𝗻𝗱 𝘄𝗶𝘀𝗱𝗼𝗺',
    breadcrumb: {
      current: 'DEPTH OF KNOWLEDGE AND WISDOM',
      previous: 'Home',
    },
    heading: '',
    mainImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/luxurysegment_portfolio.jpg',
      alt: 'depth of knowledge_mainImage',
    },
    topImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/luxurysegment_portfolio.jpg',
      alt: 'depth of knowledge_topImage',
    },
    bottomImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/luxurysegment_portfolio.jpg',
      alt: 'depth of knowledge_bottomImage',
    },
    projectData: {
      program: '',
      year: ' ',
      location: '',
    },
    title: '',
    paragraph: [
      'The man of many words and even more actions. Lion Dr. Y Kiron',
      "The 𝗱𝗲𝗽𝘁𝗵 𝗼𝗳 𝗸𝗻𝗼𝘄𝗹𝗲𝗱𝗴𝗲 𝗮𝗻𝗱 𝘄𝗶𝘀𝗱𝗼𝗺 this gentleman carries is truly remarkable.Conversations with him are never just conversations, they're 𝗺𝗮𝘀𝘁𝗲𝗿𝗰𝗹𝗮𝘀𝘀𝗲𝘀 in 𝗽𝗲𝗿𝘀𝗽𝗲𝗰𝘁𝗶𝘃𝗲, no matter the subject.",
      'A 𝗿𝗲𝗮𝗹 𝗲𝘀𝘁𝗮𝘁𝗲 #Entrepreneur, #Philanthropy, 𝗳𝗮𝘁𝗵𝗲𝗿, 𝗯𝘂𝗿𝗲𝗮𝘂𝗰𝗿𝗮𝘁, 𝗺𝗮𝘀𝘁𝗲𝗿𝗺𝗶𝗻𝗱 #Businessman, 𝗮𝗻𝗱 𝗺𝗲𝗻𝘁𝗼𝗿, these are just a few of the many hats he wears effortlessly every day.',
      'Had the privilege of reconnecting with him after a long time, and we had an enriching exchange of ideas on the current affairs of #Hyderabad and #Telangana, and 𝘄𝗵𝗲𝗿𝗲 𝘁𝗵𝗲 𝗰𝗶𝘁𝘆 𝗶𝘀 𝗵𝗲𝗮𝗱𝗲𝗱 𝗶𝗻 𝘁𝗵𝗲 𝗰𝗼𝗺𝗶𝗻𝗴 𝗱𝗲𝗰𝗮𝗱𝗲.',
      'Here’s to many more years of 𝗶𝗻𝘀𝗽𝗶𝗿𝗶𝗻𝗴 𝘁𝗵𝗲 𝘆𝗼𝘂𝗻𝗴𝗲𝗿 𝗴𝗲𝗻𝗲𝗿𝗮𝘁𝗶𝗼𝗻, they truly need guiding voices like yours now more than ever.',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    // bottomImage: "",
    finalText: [],
  },
  {
    id: ' most revered industry stalwarts',
    breadcrumb: {
      current: 'MOST REVERED INDUSTRY STALWARTS',
      previous: 'Home',
    },
    heading: '',
    mainImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/stalwarts_portfolio1.jpeg',
      alt: 'msot revered industry stalwarts_mainImnage',
    },

    topImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/stalwarts_portfolio1.jpeg',
      alt: 'most revered industry stalwarts_topImage',
    },
    bottomImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/stalwarts_portfolio2.jpg',
      alt: 'most revered industry stalwarts_bottomImage',
    },

    projectData: {
      program: '',
      year: ' ',
      location: '',
    },
    title: '',
    paragraph: [
      'It was great to meet one of the most revered industry stalwarts & someone who i have known a long time & i personally revere n hugely respect for his leadership & philanthropic interests & most importantly a grounded, humble, kind & empathetic nature.',
      "A quality that's extremely rare to find in the leaders of our times.",
      'Spent an amazing time connecting & planning on a lot of things down the line.It was great to meet with you today Anna.',
      'Sandip Patnaik- Sr. Managing Director, Board of Directors, JLL India JLL ',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    // bottomImage: "",
    finalText: [],
  },
  {
    id: ' pragathi green meadows',
    breadcrumb: {
      current: 'PRAGATHI GREEN MEADOWS',
      previous: 'Home',
    },
    heading: '',
    mainImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/pragathi_green_meadows1.jpeg',
      alt: 'pragathi green meadows_mainImage',
    },

    topImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/pragathi_green_meadows1.jpeg',
      alt: 'pragathi green meadows_topImage',
    },
    bottomImage: {
      src: 'https://dprstorage.b-cdn.net/RW/Portfolio-Linkedin/pragathi_green_meadows2.jpeg',
      alt: 'pragathi green meadows_bottomImage',
    },

    projectData: {
      program: '',
      year: ' ',
      location: '',
    },
    title: '',
    paragraph: [
      'This #WorldEnvironmentDay, my team and I stepped away from the usual hustle and spent the day at Pragati Green Meadows & Resorts Limited (Hyderabad',
      'A vast eco-space that reminded us what 𝘀𝘂𝘀𝘁𝗮𝗶𝗻𝗮𝗯𝗶𝗹𝗶𝘁𝘆 𝘁𝗿𝘂𝗹𝘆 𝗹𝗼𝗼𝗸𝘀 𝗹𝗶𝗸𝗲.',
      'We walked through organic farms,fed the cattle, connected with the land,and experienced the kind of calm only nature can offer.',
      'We had the privilege of meeting the 𝗠𝗗 𝗮𝗻𝗱 𝗗𝗶𝗿𝗲𝗰𝘁𝗼𝗿 𝗔𝗷𝗮𝘆 𝗰𝗵𝗮𝗻𝗱𝗿𝗮 𝗚𝗮𝗱𝗱𝗶𝗽𝗮𝘁𝗶,Whose commitment to long-term environmental sustainability left us truly inspired.',
      'A special thank you to Venugopal S,whose invaluable support and guidance made this exploration seamless and insightful.',
      'This visit wasn’t just a getaway — it was a 𝘄𝗮𝗸𝗲-𝘂𝗽 𝗰𝗮𝗹𝗹',
      'If we can invest so much into growth,We can choose to invest just as much into the planet.',
      'Because sustainability is no longer optional. It’s the only way forward.',
      'Let’s lead by example.𝗟𝗲𝘁’𝘀 𝗴𝗼 𝗴𝗿𝗲𝗲𝗻 — 𝗶𝗻 𝗯𝘂𝘀𝗶𝗻𝗲𝘀𝘀 𝗮𝗻𝗱 𝗯𝗲𝘆𝗼𝗻𝗱.',
      'The question now is — are we paying enough attention to where we’re headed?',
    ],
    bulletList: [],
    sectionTitle: '',
    sectionText: '',
    steps: [],
    // bottomImage: "",
    finalText: [],
  },
];

export const PortfolioDetailsNormalized = PortfolioDetailsData.map((item) => ({
  ...item,
  mainImage: toImg(item.mainImage, fallbackAlt(item, 'main'))!,
  topImage: toImg(item.topImage, fallbackAlt(item, 'top')),
  bottomImage: toImg(item.bottomImage, fallbackAlt(item, 'bottom')),
}));
